export default function camelCase(str: string): string {
  const match = str.match(/^[A-Z]+/);
  const uc = (match && match[0]) || '';
  if (!uc) {
    return str;
  }
  if (uc.length === 1) {
    return str[0].toLowerCase() + str.substring(1);
  }
  return (
    str.substring(0, uc.length - 1).toLowerCase() + str.substring(uc.length - 1)
  );
}
